<template>
  <div class="tooltip">
      <img class="tooltip__icon" :src="InfoIconSVG">
      <span class="tooltip__content">{{ content }}</span>
  </div>
</template>

<script>

import InfoIcon from '../../assets/images/icons/information.svg';

export default {
  name: 'Tooltip',

  props: {
    content: String,
  },
  computed: {
    InfoIconSVG() {
      return InfoIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip{
    transition: 0.5s all;
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 19px 0 rgba($color: #000000, $alpha: .25);
    -webkit-tap-highlight-color: rgba(0,167,233,.2);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &:after{
        position: absolute;
        left: 15px;
        bottom: -15px;
        width: 0;
        height: 0;
        border-top: 20px solid #fff;
        border-right: 20px solid transparent;
        border-left: 20px solid transparent;
        content: "";
        z-index: 1;
    }
    &__icon{
        width: 21px;
        margin-right: 15px;
    }
    &__content{
        font-size: 13px;
        font-weight: 500;
        line-height: 1.3;
    }
}
</style>
